import { atom, useRecoilState } from "recoil";

import { verifyAndFetchFeedbackConfig, fetchFeedbackConfig , saveUserFeedback} from "../services/feedback.service";
import { faOnFeedbackSubmitReset } from "../services/analytics.services";
import { API_FETCH_STATUS } from "constants/common";

const feedbackConfigAtom = atom({
	key: "feedbackConfig",
	default: null,
});

const saveFeedbackStatusAtom = atom({
	key: "saveFeedbackStatus",
	default: null,
});

const feedbackConfigStatusAtom = atom({
	key: "feedbackConfigStatus",
	default: API_FETCH_STATUS.LOADING,
});

const useFeedbackConfig = () => {
	const [feedbackConfig, setFeedbackConfig] = useRecoilState(feedbackConfigAtom);
	const [saveFeedbackStatus, setSaveFeedbackStatus] = useRecoilState(saveFeedbackStatusAtom);
	const [feedbackConfigStatus, setFeedbackConfigstatus] = useRecoilState(feedbackConfigStatusAtom)
	const validateFeedbackIdandFetchFeedbackConfig = async (uniqueId) => {
		setFeedbackConfigstatus(API_FETCH_STATUS.LOADING)
		const payload = { uniqueId };
		try {
			const res = await verifyAndFetchFeedbackConfig(payload);
			if (res.data?.status === "SUCCESS") {
				setFeedbackConfig(res.data);
				setFeedbackConfigstatus(API_FETCH_STATUS.SUCCESS)
			} else {
				setFeedbackConfig(res.data);
				setFeedbackConfigstatus(API_FETCH_STATUS.SUCCESS)
			}
		} catch (error) {
			setFeedbackConfig(error);
		}
	};

	const fetchFeedbackConfigData = async (payload) => {
		const payloadData= {...payload,widgetId:"atbFeedbackV2"}
		setFeedbackConfigstatus(API_FETCH_STATUS.LOADING)
		try {
			const res = await fetchFeedbackConfig(payloadData);
			if (res.status === 200) {
				setFeedbackConfig(res.data);
				setFeedbackConfigstatus(API_FETCH_STATUS.SUCCESS)
			} else {
				setFeedbackConfig(res.data);
				setFeedbackConfigstatus(API_FETCH_STATUS.ERROR)
			}
		} catch (error) {
			setFeedbackConfig(API_FETCH_STATUS.ERROR);
		}
	};
	
		const saveFeedback = async (payload) => {
			setSaveFeedbackStatus(API_FETCH_STATUS.LOADING);
			try {
				const res = await saveUserFeedback(payload);
				if (res.data?.status === "SUCCESS") {
					setSaveFeedbackStatus(API_FETCH_STATUS.SUCCESS);
				} else {
					throw new Error(res);
				}
				faOnFeedbackSubmitReset();
			} catch (error) {
				setSaveFeedbackStatus(API_FETCH_STATUS.ERROR);
			}
		};

return { feedbackConfig, validateFeedbackIdandFetchFeedbackConfig,fetchFeedbackConfigData,saveFeedbackStatus,saveFeedback,feedbackConfigStatus,setSaveFeedbackStatus };

}

export default useFeedbackConfig;
